import { Helmet } from "react-helmet";
import {
    Box,
    Container,
    Grid,
    Typography
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { ReactComponent as PermissionDeniedIcon } from "../assets/icons/permissionDenied.svg";

const PermissionDenied = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box style={{ overflow: "hidden", height: "calc(100vh - 64px)" }}>
            <Helmet>
                <title>PERMISSION DENIED | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <Box sx={{ textAlign: "center" }} pt="75px">
                    <Typography color="#5DA196" fontSize={40} lineHeight="59.8px" fontWeight="600" >
                        Permission Denied
                    </Typography>
                    <Typography color="#404349" fontSize={20} lineHeight="29.9px" fontWeight="500" >
                        Sorry, you don’t have permission to access this page.
                    </Typography>
                    <Typography color="#404349" fontSize={20} lineHeight="29.9px" fontWeight="500" mb="30px" >
                        Please go back to <span onClick={e => navigate('/kpi/home', { replace: false })} style={{ color: "#5DA196", fontWeight: "600", cursor: "pointer" }}>Home</span>
                    </Typography>
                    <PermissionDeniedIcon />
                </Box>
            </Box>
        </Box>
    );
};
export default PermissionDenied;
